import fetchRequest from '@/app/_utils/fetch-request'
import { isNotFoundFetchError, reportFetchError } from '@/app/_utils/handle-fetch-error'
import { IS_ON_SERVER } from '@/app/_utils/select-api-service'
import { ServiceName } from '@/app/_utils/types'

import { PLPPages, PLPSlug } from '../types'

export async function getPLPBasicMetas(page: PLPPages, slug: PLPSlug, isServerSideRequest = false) {
    let serviceName: ServiceName = 'cml'
    let endpoint = ''

    if (page === PLPPages.Tags) {
        endpoint = `/tags/slug/${slug}`
    } else if (page === PLPPages.Facets) {
        endpoint = `/combinations/slug/${slug}`
    } else if (page === PLPPages.BrandCategoriesCombination) {
        endpoint = `/combinations/type/CategoryBrand/slug/${slug}`
    } else {
        serviceName = 'ntl'
        endpoint = `/catalog/${page}/slug/${slug}`
    }

    try {
        const result = await fetchRequest({
            endpoint,
            serviceName,
            appendCurrentQueryStrings: true,
            isServerSideRequest: IS_ON_SERVER && isServerSideRequest,
        })

        return result
    } catch (error) {
        if (isNotFoundFetchError(error)) return null

        throw reportFetchError(
            'error-fetching-basic-metas',
            `ServiceName: ${serviceName}, Endpoint: ${endpoint}`,
            error
        )
    }
}
